import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { FaUserCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom"
import { setSingupData } from "../../../redux/slices/authSlice"
import OtpInput from 'react-otp-input';
import { apiConnector } from "../../../services/apiconnector"
import { toast } from "react-hot-toast"
import {signUp} from "../../../services/operations/authAPI"
import { useDispatch, useSelector } from "react-redux"
import addbook from "../../../assets/addbook.png"
import { setLoading } from "../../../redux/slices/authSlice";

import Upload from "./Upload";



function AddBook() {
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [otp, setOtp] = useState('');
  const [otpMatch, setOtMatch] = useState('');
  const [file, setFile] = useState(null);
  const { book, editBook } = useSelector((state) => state.book)

  const [email,setEmaill] = useState('')


  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const uploadPhoto = (e) => {
    setFile(e.target.files[0]);  // Set the file to the 'file' state
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setValue("image", reader.result);  // Update the form value with the data URL (optional)
    };
    reader.readAsDataURL(file);  // Read the file as a data URL
  };
  

const sendOtpHandler = async()=>{
console.log(email)
const toastId = toast.loading("Loading...")
// dispatch(setLoading(true))

  try {
    const response = await apiConnector("POST",`${process.env.REACT_APP_BASE_URL}/auth/sendotp` , {
      email,
      checkUserPresent: true,
    },
    {
          Authorization: `Bearer ${token}`,
    },
    )
    console.log("SENDOTP API RESPONSE............", response)
      setOtMatch(response.data.otp)
    console.log(response.data.otp)

    if (!response.data.success) {
      throw new Error(response.data.message)
    }

    toast.success("OTP Sent Successfully")
 
  } catch (error) {
    console.log("SENDOTP API ERROR............", error)
    toast.error("Could Not Send OTP")
  }
  // dispatch(setLoading(false))
  toast.dismiss(toastId)

}

  const onSubmit = async (data) => {
    // console.log(token)
if(otp!==otpMatch){
  toast.error("Otp does not matched")
}
    console.log(data)
    console.log(data.image)


  console.log(file)

    const formData = new FormData()
    formData.append("image", file);

    formData.append("className",data.className)
    formData.append("contactNumber",data.contactNumber)
    formData.append("email",email)
    formData.append("firstName",data.firstName)
    formData.append("gender",data.gender)
    formData.append("lastName",data.lastName)
    formData.append("libraryId",data.libraryId)
    formData.append("password",data.password)
    formData.append("session",data.session)
    formData.append("image",data.image)

    formData.append("otp",otp)
    
  
    console.log(data);
  
    // const signupData = {
    //   formData,
    // };

    // dispatch(setSingupData(signupData));
    setLoading(true)
        dispatch(
    signUp(formData,
       token)
  )
    
    setLoading(false)


  };




  return (
    <div className="">
      <div className="flex flex-col gap-8 bg-richblack-200 p-4 rounded-xl ">
      
      <div className="flex relative justify-between">
      <h1 className="text-2xl font-mulish font-bold">Register A Student</h1>
      <img className=" "
      src={addbook} 
      width={50}
      alt="" />
      </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-5 rounded-md border-[1px] border-richblack-700 bg-transparent p-2"
        >
          {/* First Row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* 1st Name */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="firstName"
              >
                First Name <sup className="text-red">*</sup>
              </label>
              <input
                id="firstName"
                placeholder=" First Name"
                {...register("firstName", { required: true })}
                className="two-style "
              />
              {errors.firstName && (
                <span className="ml-2 text-xs tracking-wide text-red">
                 First Name is required
                </span>
              )}
            </div>

            {/* Last Name */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="lastName"
              >
               LastName <sup className="text-red">*</sup>
              </label>
              <input
                id="lastName"
                placeholder="Last Name"
                {...register("lastName", { required: true })}
                className="two-style"
              />
              {errors.lastName && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book Author is required
                </span>
              )}
            </div>
          </div>
          {/* second row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* email */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label
                className="text-sm text-richblack-900"
                htmlFor="email"
              >
                Email-ID <sup className="text-red">*</sup>
              </label>
              <input
                id="email"
                placeholder="Email Id"
                value={email}
                onChange={(e)=>setEmaill(e.target.value)}
              
                className="two-style "
              />
             
            </div>

            {/* Password */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label className="text-sm text-richblack-900" htmlFor="password">
               Password <sup className="text-red">*</sup>
              </label>
              <input
                id="password"
                type="Password"
                placeholder="Password"
                {...register("password", { required: true })}
                className="two-style"
              />
              {errors.password && (
                <span className="ml-2 text-xs tracking-wide text-red">
                password is required
                </span>
              )}
            </div>
          </div>

          {/* 3rd Row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Book Add Date */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label
                className="text-sm text-richblack-900"
                htmlFor="className"
              >
               className <sup className="text-red">*</sup>
              </label>
              <input
                id="className"
                 {...register("className", { required: true })}
                 placeholder="Classname"
                className="two-style "
              />
              {errors.className && (
                <span className="ml-2 text-xs tracking-wide text-red">
                className  is required
                </span>
              )}
            </div>

            {/* Book Cetegory */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label className="text-sm text-richblack-900" htmlFor="gender">
                Gender<sup className="text-red">*</sup>
              </label>
              <select
                {...register("gender", { required: true })}
                defaultValue=""
                id="gender"
                className="form-style w-full"
              >
                <option value="" >
                  Choose gender
                </option>

                <option value="Male" >
                 Male
                </option>

                <option value="Female" >
                 Female
                </option>
                
              </select>

              {errors.gender && (
                <span className="ml-2 text-xs tracking-wide text-red">
                 gender is required
                </span>
              )}
            </div>
          </div>

          {/* 4th row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* libraryId */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label className="text-sm text-richblack-900" htmlFor="libraryId">
              LibraryId No. <sup className="text-red">*</sup>
              </label>
              <input
                id="libraryId"
                placeholder="Library Id No."
                {...register("libraryId", { required: true })}
                className="two-style "
              />
              {errors.libraryId && (
                <span className="ml-2 text-xs tracking-wide text-red">
                libraryId is required
                </span>
              )}
            </div>

            {/* Images */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
                                <label
                                  className="text-sm text-richblack-900"
                                  htmlFor="image"
                                >
                                Student Image <sup className="text-red">*</sup>
                                </label>
                                <input
                                  id="image"
                                  type="file"
                                  accept=".png, .jpg, .jpeg"
                                  name="image"
                                  onChange={(e) => uploadPhoto(e)}
                                  placeholder="Student Image "
                                  // {...register("image", { required: true })}
                                  className="two-style"
                                />
                                {errors.image && (
                                  <span className="ml-2 text-xs tracking-wide text-red">
                                    Book bookID is required
                                  </span>
                                )}

                                {/* <Upload
                                        name="image"
                                        label="Student Image"
                                        register={register}
                                        setValue={setValue}
                                        errors={errors}
                                        editData={editBook ? book?.thumbnail : null}
                                                                   /> */}
            </div>
          </div>
         
          {/* 5th row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Contact Number */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label className="text-sm text-richblack-900" htmlFor="contactNumber">
                 Mobile Number <sup className="text-red">*</sup>
              </label>
              <input
                id="contactNumber"
                type="number"
                placeholder="Contact Number"
                {...register("contactNumber", { required: true })}
                className="two-style "
              />
              {errors.contactNumber && (
                <span className="ml-2 text-xs tracking-wide text-red">
                contactNumber is required
                </span>
              )}
            </div>

            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label className="text-sm text-richblack-900" htmlFor="session">
                 Session <sup className="text-red">*</sup>
              </label>
              <input
                id="session"
                               placeholder="Session"
                {...register("session", { required: true })}
                className="two-style "
              />
              {errors.session && (
                <span className="ml-2 text-xs tracking-wide text-red">
                session is required
                </span>
              )}
            </div>


           


            {/* OTP  */}
          </div>
          <div className="flex flex-col space-y-2  lg:lg:w-[32%]  w-full md:w-[47%] ">
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderInput={(props) => (
                          <input
                            {...props}
                            placeholder="-"
                            style={{
                              boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
                            }}
                            className="w-[40px] border-0 bg-richblack-800 rounded-[0.5rem] text-richblack-5 aspect-square text-center focus:border-0 focus:outline-2 focus:outline-yellow-50"
                          />
                        )}
                        containerStyle={{
                          justifyContent: "space-between",
                          gap: "0 6px",
                        }}
                      />
                      <p
                      onClick={sendOtpHandler}
                        className="rounded-[8px] w-fit mt-6 font-medium text-richblack-900  bg-richblack-100 p-1 px-5 cursor-pointer"
                      >
                        Send Otp
                      </p>
            </div>
         <div className="w-full flex lg:justify-center pt-4">

              <button 
              className="flex items-center gap-x-2 p-2 px-4 bg-yellow-100 rounded-xl font-mulish font-semibold hover:bg-yellow-50">
               <FaUserCheck /> <span>Registered Student</span>
              </button>

         </div>
        </form>
      </div>
    </div>
  );
}

export default AddBook;
